module.exports = __webpack_public_path__ + "img/v07.9466361c.jpg";